import { createFileRoute } from '@tanstack/react-router';
import { Hydrate } from '@tanstack/react-start';
import { idle } from '@tanstack/react-start/hydration';
import { useMemo } from 'react';
import { NoteContent } from '#/components/notes/note-content.tsx';
import { extractHeadings } from '#/components/notes/table-of-contents.utils.ts';
import Md from './play.md?raw';

export const Route = createFileRoute('/admin/play-md')({
	component: RouteComponent,
});

function RouteComponent() {
	const headings = useMemo(() => (Md ? extractHeadings(Md) : []), []);

	return (
		<div className="pb-10">
			<section className="container min-w-0">
				<Hydrate when={idle()}>
					<NoteContent content={Md} headings={headings} />
				</Hydrate>
			</section>
		</div>
	);
}
